module.exports = __webpack_public_path__ + "img/maybank.e8c20e3b.jpg";